<template>
	<div>
		<Layout :navFixed="true" :transparent="true">
			<HomeSlider />

			<!-- 
					Eventos en vivo ahora mismo
				 -->
			<!-- <div class="row mb-3">
					<div class="col ">
						<div class="d-flex">
							<h3 class="mt-2">Eventos destacados</h3>
						</div>
					</div>
				</div> -->

			<!-- <div class="search-box">
				<div class="box">
					Buscador por nombre y categoria de evento
				</div>
			</div> -->

			<!-- <div class="container mb-3">
				<div class="row">
					<div class="col-12 col-sm-6 col-md-4 col-lg-3 " v-for="item in list" :key="item.id">
						<div>
							<EventItem :event="item" />
						</div>
					</div>
				</div>
			</div> -->

			<!-- <div class="promoter-banner">
				<h3>¿Eres organizador de eventos?</h3>
				<p>Venda entradas online, registrate y transformá tus eventos!</p>
				<router-link class="btn btn-outline-light" tag="a" to="/">Comenzar</router-link>
			</div> -->
		</Layout>
	</div>
</template>

<script>
import gql from "graphql-tag"
import Layout from "@/components/Layout"
import EventItem from "@/views/events/EventItem"
import HomeSlider from "./HomeSlider"

export default {
	name: "Home",
	components: {
		Layout,
		EventItem,
		HomeSlider
	},
	data() {
		return {
			loading: false,
			list: []
		}
	},

	async beforeMount() {
		this.filters = this.getValidUrlParams()
		await this.load()
	},

	methods: {
		load() {
			this.loading = true
			return this.$apollo
				.query({
					query: gql`
						query($take: Int, $skip: Int, $featured: Boolean) {
							events(take: $take, skip: $skip, featured: $featured) {
								data {
									id
									code
									name
									startAt
									endAt
									description
									image {
										id
										type
										filename
										url
										urlThumb
									}
									location {
										id
										name
										locality {
											name
											region {
												name
											}
										}
										address
										latlng {
											lat
											lng
										}
									}

									status
									statusText
									statusClass
								}
								pageInfo {
									totalItems
								}
							}
						}
					`,
					variables: {
						take: this.pagination.length,
						skip: this.pagination.skip,
						featured: true
					},
					fetchPolicy: "network-only"
				})
				.then(({ data }) => {
					this.list = data.events.data
					this.pagination.pageInfo = data.events.pageInfo
					this.loading = false
				})
		}
	}
}
</script>

<style scoped lang="scss">
.promoter-banner {
	margin: 24px 0;
	padding: 34px;
	background-color: #000;
	color: #fff;
	text-align: center;

	p {
		font-size: 1.2rem;
	}

	.btn-outline-light {
		color: #fff;
		border: solid 2px;
		padding: 0.375rem 1.2rem;
		margin: auto;
	}
}
</style>
